
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Key, Shield, Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface LicenseKeysHeaderProps {
  onCreateDialogOpen: () => void;
}

const LicenseKeysHeader: React.FC<LicenseKeysHeaderProps> = ({ onCreateDialogOpen }) => {
  const navigate = useNavigate();
  
  return (
    <header className="mb-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between">
        <div>
          <h1 className="text-3xl font-bold flex items-center">
            <Key className="mr-2 h-6 w-6 text-indigo-600" />
            License Keys
          </h1>
          <p className="text-gray-600 mt-1">
            Manage and create license keys for Super Admins
          </p>
        </div>
        <div className="mt-4 md:mt-0 flex gap-2">
          <Button variant="outline" onClick={() => navigate('/master-license/dashboard')}>
            <Shield className="mr-2 h-4 w-4" />
            Dashboard
          </Button>
          <Button onClick={onCreateDialogOpen}>
            <Plus className="mr-2 h-4 w-4" />
            Create License Key
          </Button>
        </div>
      </div>
    </header>
  );
};

export default LicenseKeysHeader;
